module.exports = __webpack_public_path__ + "img/640ef86af4b4a977fe0daa5b.64b55e5f.svg";